import { Api } from "./Api";
import { Note } from "../models/Note";

export class NoteApi extends Api {
    constructor() {
        super("note");
    }

    getAll(params?: Object): Promise<Array<Note>> {
        return this.getResources(params).then(function (response) {
            let res: Array<Note> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (n) {
                    return new Note(n);
                });
            }
            return res;
        });
    }

    getCount(params: Object): Promise<Number> {
        params = _.assign(params, { count: true });
        return this.getResources(params).then(function (response) {
            return response.data;
        });
    }

    save(note: Note, params?: Object): Promise<Note> {
        return super.saveResource(note, params).then(function (response) {
            return new Note(response.data.data);
        });
    }

    delete(id: Number, raison: string): Promise<Note> {
        return super.deleteResource(id, raison).then(function (response) {
            return new Note(response.data.data);
        });
    }
}
